<template>
    <svg
        aria-hidden="true"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 300 300"
        class="blur-[2px] transition-all ease-in"
        :style="{ transform: `scale(${scaleLevel})` }"
        :class="{ speaking: isSpeaking, reconnecting: isReconnecting, paused: isPaused }">
        <defs>
            <filter id="displacement-filter" color-interpolation-filters="sRGB">
                <feImage id="displacement-map" :href="Marble" x="0" y="0" width="300" height="300" />
                <feDisplacementMap in="SourceGraphic" in2="displacementMap" scale="130" xChannelSelector="G" yChannelSelector="G" />
                <feGaussianBlur stdDeviation="15" />
            </filter>

            <pattern id="imagePattern" patternUnits="userSpaceOnUse" width="600" height="600">
                <image id="source-image" :href="gradient" width="600" height="600" preserveAspectRatio="xMidYMid slice" />
                <animateTransform attributeName="patternTransform" type="translate" values="600,0;0,600" dur="4s" repeatCount="indefinite" fill="freeze" />
            </pattern>

            <mask id="circleMask">
                <circle cx="150" cy="150" r="150" fill="white" />
            </mask>
        </defs>
        <rect width="300" height="300" fill="url(#imagePattern)" mask="url(#circleMask)" style="filter: url(#displacement-filter)" />
    </svg>
</template>

<script setup>
import gradient from "~img/gradient.jpg";
import Marble from "~img/realtime_chat.svg";
import { computed } from "vue";

const { state, level } = defineProps({
    state: {
        type: String,
        required: true,
    },
    level: { type: Number, default: 1.5 },
});

const isSpeaking = computed(() => state === "speaking");
const isReconnecting = computed(() => state === "reconnecting");
const isPaused = computed(() => state === "paused");

const MIN_THRESHOLD = 1.085;
const MAX_THRESHOLD = 1.25;
const scaleLevel = computed(() => (level + 1 > MIN_THRESHOLD ? Math.min(level + 1, MAX_THRESHOLD) : 1));
</script>

<style scoped>
.speaking {
    animation: spin 4s linear infinite;
}

.reconnecting {
    opacity: 0.5;
    animation: pulse 2s ease-in-out infinite;
}

@keyframes pulse {
    0%,
    100% {
        opacity: 0.5;
    }
    50% {
        opacity: 0.3;
    }
}

.paused {
    opacity: 0.4;
    filter: grayscale(0.5);
    transition:
        opacity 0.3s ease,
        filter 0.3s ease;
}
</style>
